<ng-container *ngIf="integrateLogs$ | async; let integrateLogs">
  <ng-container *ngIf="integrateLogs.loading">
    <strong>carregando...</strong>
  </ng-container>

  <ng-container *ngIf="integrateLogs.failure">
    <peca-retry context="logs de integração do pedido" (retry)="onRetry()" />
  </ng-container>

  <ng-container *ngIf="integrateLogs.data && !integrateLogs.data.length">
    <pds-alert type="info" title="Nenhum registro de integração">
      <span>Nenhum registro de integração para esse pedido.</span>
    </pds-alert>
  </ng-container>

  <pds-table *ngIf="integrateLogs.data && integrateLogs.data.length">
    <table>
      <thead>
        <tr>
          <th>Data / Hora</th>
          <th>Origem</th>
          <th>Cliente</th>
          <th>Tipo de evento</th>
          <th>Status</th>
          <th>Latência</th>
          <th>URL</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let log of integrateLogs.data">
          <td>{{ log.createdAt | date : 'dd/MM/yyyy HH:mm:ss' }}</td>
          <td>{{ log.origin }}</td>
          <td>{{ log.clientId }}</td>
          <td>{{ log.eventType }}</td>
          <td>
            <span pdsChip [class]="log.responseStatus >= 200 && log.responseStatus < 300 ? '--success' : '--danger'">
              {{ log.responseStatus }}
            </span>
          </td>
          <td>{{ log.latencyInMillis }} ms</td>
          <td>
            <a [href]="log.url" target="_blank" rel="noopener noreferrer">{{ log.url }}</a>
          </td>
        </tr>
      </tbody>
    </table>
  </pds-table>
</ng-container>
